import BrandList from './components/BrandList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import { connect } from 'react-redux';

import {loadBrands, loadAgencies, updateBrand, loadReceiptLineups, loadPromotions} from '../../shared/redux/entities/actions'

import { loadKPIsForBrands } from '../../shared/redux/kpis/actions';

function mapStateToProps(state,props){
  const brands = values(state.entities.companies)
    .filter((b) => b.name && b.name.length > 0 && b.isBrand)
    .sort((a,b) => (a.name || '').localeCompare((b.name || '')))
    .map((b) => {
      b.totalCampaigns = get(state,['kpis','brands',b.id,'totalCampaigns'],0);
      b.agencyName = get(state,['entities','agencies',b.agencyId,'name']);
      
      return b;
    });

  return {
    brands:brands
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    updateBrand,
    loadBrands,
    loadAgencies,
      loadReceiptLineups,
      loadPromotions,
    loadKPIsForBrands
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(BrandList));



// WEBPACK FOOTER //
// ./src/routes/BrandList/index.js